"use client";

import { type ReactNode, createContext, useContext } from "react";
import type { OptionListMap } from "./option-lists";

// Defaults to empty so a component outside the provider falls back to the JSON.
const OptionListsContext = createContext<OptionListMap>({});

export const OptionListsProvider = ({
	lists,
	children,
}: {
	lists: OptionListMap;
	children: ReactNode;
}) => (
	<OptionListsContext.Provider value={lists}>
		{children}
	</OptionListsContext.Provider>
);

export const useOptionLists = (): OptionListMap =>
	useContext(OptionListsContext);
